import { render } from "./MaisView.vue?vue&type=template&id=212a1e24"
import script from "./MaisView.vue?vue&type=script&lang=js"
export * from "./MaisView.vue?vue&type=script&lang=js"

import "./MaisView.vue?vue&type=style&index=0&id=212a1e24&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__